import React from 'react';
import {
    ContactAvatar,
    ContactName,
    DataType,
    MemberItem,
    ValuePanel,
    ValueItem,
    ValuePanelProps
} from '@fx-ui/jdy-design-biz';
import MemberName from '../member-name';
import { platformIntl } from '../../constants';

interface ContactValuePanelProps<T> extends Omit<ValuePanelProps<T>, 'renderIcon' | 'renderName'> {
    dataType?: DataType;
    /**
     * 部门是否递归
     */
    recursion?: boolean;
    allowRemove?: boolean;
    renderIcon?: (item: ValueItem<T>) => React.ReactElement | false;
    renderName?: (item: ValueItem<T>) => React.ReactNode | false;
}

const ContactValuePanel = <T extends { dataType?: DataType }>(props: ContactValuePanelProps<T>) => {
    const { dataType, emptyText, recursion, renderIcon, renderName, ...otherProps } = props;

    const renderEmptyText = () => {
        if (emptyText) {
            return emptyText;
        }
        switch (dataType) {
            case DataType.member: {
                return platformIntl.get('select.member');
            }
            case DataType.dept: {
                return platformIntl.get('select.dept');
            }
            case DataType.role: {
                return platformIntl.get('select.role');
            }
            default: {
                return platformIntl.get('select.contact');
            }
        }
    };

    const renderContactIcon = (item: ValueItem<T>) => {
        if (renderIcon) {
            const icon = renderIcon(item);
            if (icon !== false) {
                return icon;
            }
        }
        return (
            <ContactAvatar
                dataType={dataType || item.dataType}
                item={item}
                deptRecursion={recursion}
            />
        );
    };

    const renderContactName = (item: ValueItem<T>) => {
        if (renderName) {
            const name = renderName(item);
            if (name !== false) {
                return name;
            }
        }
        const type = dataType || item.dataType;
        if (type === DataType.member) {
            const member = item as any as MemberItem;
            return <MemberName name={member.nickname} status={member.status} type={member.type} />;
        }
        return <ContactName dataType={type} item={item} />;
    };

    return (
        <ValuePanel<ValueItem<T>>
            {...otherProps}
            emptyText={renderEmptyText()}
            renderIcon={renderContactIcon}
            renderName={renderContactName}
        />
    );
};

export default ContactValuePanel;
